__turbopack_context__.v({
  "l11": "loader-module-scss-module__bLaSdq__l11",
  "loader": "loader-module-scss-module__bLaSdq__loader",
  "loaderWrapper": "loader-module-scss-module__bLaSdq__loaderWrapper",
});
